var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPause(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22 44C25.0052 44 27.8307 43.4248 30.4765 42.2745C33.1366 41.1242 35.4804 39.5353 37.5078 37.5078C39.5353 35.4804 41.1242 33.1438 42.2745 30.498C43.4248 27.8379 44 25.0052 44 22C44 18.9948 43.4248 16.1693 42.2745 13.5235C41.1242 10.8634 39.5353 8.51961 37.5078 6.49216C35.4804 4.46471 33.1366 2.87582 30.4765 1.72549C27.8163 0.575163 24.9837 0 21.9784 0C18.9732 0 16.1405 0.575163 13.4804 1.72549C10.8346 2.87582 8.49804 4.46471 6.47059 6.49216C4.45752 8.51961 2.87582 10.8634 1.72549 13.5235C0.575163 16.1693 0 18.9948 0 22C0 25.0052 0.575163 27.8379 1.72549 30.498C2.87582 33.1438 4.46471 35.4804 6.49216 37.5078C8.51961 39.5353 10.8562 41.1242 13.502 42.2745C16.1621 43.4248 18.9948 44 22 44ZM13 14C13 12.8954 13.8954 12 15 12H17C18.1046 12 19 12.8954 19 14V30C19 31.1046 18.1046 32 17 32H15C13.8954 32 13 31.1046 13 30V14ZM27 12C25.8954 12 25 12.8954 25 14V30C25 31.1046 25.8954 32 27 32H29C30.1046 32 31 31.1046 31 30V14C31 12.8954 30.1046 12 29 12H27Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPause);
export default __webpack_public_path__ + "static/media/pause.669c234b6945626d8f5124956ce4b865.svg";
export { ForwardRef as ReactComponent };